import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';
import MagnifyIcon from '~/icons/Magnify';

// Main keyword search component that's brought into header component
export const KeywordSearchWrapper = styled.div.attrs({
  className:
    'absolute bg-white border border-grey-2 border-solid grid items-center rounded l:!w-full'
})`
  width: ${props => (props.inputFocus ? '100%' : props.width)};
  transition: width 300ms linear;
  grid-template-columns: 1fr auto auto;

  max-width: ${props =>
    props.isStickySearchbar && !props.inputFocus ? '650px' : undefined};

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    max-width: ${props => (props.isStickySearchbar ? '400px' : undefined)};
  }

  @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
    max-width: ${props => (props.isStickySearchbar ? '650px' : undefined)};
  }
  @media (min-width: ${props => props.theme.breakpoints.values.xl}px) {
    max-width: ${props => (props.isStickySearchbar ? '912px' : undefined)};
  }
`;

// Main search bar wrapper
export const stickyBarHeightMobile = 40;
export const stickyBarHeightDesktop = 46;
export const barHeightMobile = 45;
export const barHeightDesktop = 55;
export const SearchBarContainer = styled.div.attrs({
  className:
    'bg-grey-1 focus:bg-white grid hover:bg-white items-center justify-items-start m-0 max-w-full relative'
})`
  grid-template-columns: 32px 1fr auto;
  height: ${props =>
    props.isStickySearchbar ? stickyBarHeightMobile : barHeightMobile}px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    grid-template-columns: 35px 1fr auto;
    height: ${props =>
      props.isStickySearchbar ? stickyBarHeightDesktop : barHeightDesktop}px;
  }
`;

// Search bar magnifying glass icon

export const SearchIcon = styled(MagnifyIcon).attrs({
  className: '-translate-x-[3px] h-16 w-16 m:h-18 m:translate-x-0 m:w-18'
})`
  path {
    fill: var(--cvna-color-blue-6);
  }

  &.grey-fill {
    path {
      fill: var(--cvna-color-grey-5);
    }
  }
`;

export const SearchIconWrapper = createComponent('div', {
  className: 'flex h-full items-center justify-end w-full'
});

export const StickyHeaderText = createComponent('p', {
  className: 'font-bold m-0 pr-16 text-[14px] text-white uppercase l:pr-0',
  'data-qa': 'sticky-header-text'
});
